// export const downloadURL = "https://elmisbackend.support.af/Documents"
export const downloadURL = "https://api.elmis.af/Documents"
// export const downloadURL = "https://api.afga.elmis.af/Documents"
//export const downloadURL = "http://localhost:8000/Documents"
